import { createContext, useContext } from "react";
import type { ReleaseNote } from "./releases";

export interface WhatsNew {
  /** Every published release, newest first (the /whats-new page). */
  published: readonly ReleaseNote[];
  /** The "new" dot on the entry points: a published release this person has not seen yet. */
  showDot: boolean;
  /** Records the newest release as seen (server side, per person). Does nothing in test mode or for an AI agent. */
  markSeen: () => void;
  /**
   * True while the release dialog is due, open, or was opened during this page load, and while that is not yet known. The
   * guided tours (welcome tour and the "มีอะไรใหม่" prompt) start nothing by themselves while it is true, so they never stack
   * with it; they wait for the next page load (ruling of 17 Oct 2026).
   */
  holdTours: boolean;
}

const OFF: WhatsNew = { published: [], showDot: false, markSeen: () => undefined, holdTours: false };

export const WhatsNewContext = createContext<WhatsNew>(OFF);

export function useWhatsNew(): WhatsNew {
  return useContext(WhatsNewContext);
}
